module.exports = __webpack_public_path__ + "e4641b1e5b8e903fbc592d6507bb3f4f.MP3";